import * as React from "react";

export type SliderAdapter = (props: {
  /** current value within [min,max] */
  value: number;
  /** label for a11y */
  ariaLabel?: string;
  min?: number;
  max?: number;
  step?: number;
  onChange: (value: number) => void;
  className?: string;
}) => React.ReactElement;

let impl: SliderAdapter | null = null;
export const registerSlider = (adapter: SliderAdapter) => {
  impl = adapter;
};

export const Slider: React.FC<{
  value: number;
  ariaLabel?: string;
  min?: number;
  max?: number;
  step?: number;
  onChange: (value: number) => void;
  className?: string;
}> = ({ value, ariaLabel, min, max, step, onChange, className }) => {
  if (!impl) return <span style={{ display: "none" }} />;
  return impl({ value, ariaLabel, min, max, step, onChange, className });
};
